/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Axios from 'axios';
import PortalConfig from '../../../data/config';
import Cookies from 'js-cookie';
import { Link } from "react-router-dom";
import Alert from '../../Alerts/Alert';

// Echarts
import * as echarts from 'echarts/core';
import { TooltipComponent, LegendComponent, GridComponent } from 'echarts/components';
import { PieChart, LineChart, BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { faFileInvoice, faTasks } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { FilterIcon } from '@heroicons/react/solid';

echarts.use(
    [TooltipComponent, LegendComponent, PieChart, LineChart, BarChart, CanvasRenderer, GridComponent]
);

const no_data_message = 'No record to display.';
const ticketFilter = {
    today: 'Today',
    current_week: 'Current Week',
    last_week: 'Last Week',
    current_month: 'Current Month',
    last_month: 'Last Month'
};

class Dashboard extends Component
{
    state = {
        message: '',
        data: [],
        openticketPriorityMenu: false,
        openticketPriorityMessage: false,
        openticketStatusMenu: false,
        openticketStatusMessage: false,

        ticket_filter: {
            status: 'current_month',
            priority: 'current_month'
        },
        loading: false,
    };

    constructor(props) {
        super(props);
        this.redirectToModule = this.redirectToModule.bind(this);
        this.applyTicketFileter = this.applyTicketFileter.bind(this);
    }

    componentDidMount() {
        // Get data needed for Dashboard module
        this.getDashboardData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if( prevState.ticket_filter !== this.state.ticket_filter ){
            this.getDashboardData();
        }
    }

    // Apply ticket filter
    applyTicketFileter(event){
        let type = event.target.getAttribute('data-type');
        let filter = event.target.getAttribute('data-filter');
        let ticketFilter = Object.assign({}, this.state.ticket_filter);
        ticketFilter[type] = filter;
        this.setState({ ticket_filter: ticketFilter });
        this.setState({openticketStatusMenu: false});
        this.setState({openticketPriorityMenu: false});
    }

    // Redirect to module's list view
    redirectToModule(module) {
        this.props.history.push(process.env.PUBLIC_URL + '/' + module);
    }

    /**
     * Get dashboard
     */
    getDashboardData() {
        // Show loading icon
        this.setState({
            loading: true,
        });

        const token = Cookies.get('wx_portal_auth');
        const config = {
            headers: {
                Authorization: 'bearer ' + token,
            }
        };
        let filter = JSON.stringify(this.state.ticket_filter);
        let end_point = PortalConfig.crm_url + '/dashboard?filter='+filter;

        Axios.get(end_point, config).then((response) => {
            this.setState({
                data: response.data,
                loading: false,
            });

            if(response.data.tasks && response.data.tasks.length > 0) {
                let taskChartDom = document.getElementById('tasks');
                let taskChart = echarts.init(taskChartDom);
                let taskLabels = [];
                let taskValues = [];
                response.data.tasks.forEach((value, index) => {
                    taskLabels.push(response.data.tasks[index]['status']);
                    taskValues.push(response.data.tasks[index]['total']);
                });

                let taskOption = {
                    xAxis: {
                        type: 'category',
                        data: taskLabels
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: taskValues,
                        type: 'line'
                    }]
                };

                taskOption && taskChart.setOption(taskOption);
            }

            if(response.data.open_ticket_by_priority.data && response.data.open_ticket_by_priority.data.length > 0) {
                this.setState({openticketPriorityMessage: false});
                let priorityChartDom = document.getElementById('open_tickets_by_priority');
                let priorityChart = echarts.init(priorityChartDom);
                let priorityData = [];
                response.data.open_ticket_by_priority.data.forEach((value, index) => {
                    priorityData.push({
                        name: response.data.open_ticket_by_priority.labels[index],
                        value: response.data.open_ticket_by_priority.data[index],
                    })
                });

                let priorityOption = {
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        top: '5%',
                        left: 'center'
                    },
                    series: [
                        {
                            name: 'Open Tickets by Priority',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                borderRadius: 10,
                                borderColor: '#fff',
                                borderWidth: 2
                            },
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '40',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: priorityData,
                        }
                    ]
                };
                priorityOption && priorityChart.setOption(priorityOption);

            } else {
                this.setState({openticketPriorityMessage: true});
            }

            if(response.data.tickets_by_status.data && response.data.tickets_by_status.data.length > 0) {
                this.setState({openticketStatusMessage: false});
                let statusChartDom = document.getElementById('tickets_by_status');
                let statusChart = echarts.init(statusChartDom);
                let statusData = [];
                response.data.tickets_by_status.data.forEach((value, index) => {
                    statusData.push({
                        name: response.data.tickets_by_status.labels[index],
                        value: response.data.tickets_by_status.data[index],
                    })
                });

                let statusOption = {
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        top: '5%',
                        left: 'center'
                    },
                    series: [
                        {
                            name: 'Tickets by status',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                borderRadius: 10,
                                borderColor: '#fff',
                                borderWidth: 2
                            },
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '40',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: statusData,
                        }
                    ]
                };
                statusOption && statusChart.setOption(statusOption);

            } else {
                this.setState({openticketStatusMessage: true});
            }

            if(response.data.tasks_all_vs_closed && response.data.tasks_all_vs_closed.length > 0) {
                let taskChartDom = document.getElementById('tasks_all_vs_closed');
                let taskChart = echarts.init(taskChartDom);

                let taskData = {
                    All: [],
                    Closed: [],
                };

                let taskLabels = [];
                // Preparing labels and data
                response.data.tasks_all_vs_closed.forEach((value) => {
                    taskLabels.push(value['created_date']);
                    taskData['All'].push(value['total']);
                    taskData['Closed'].push(value['closed_tasks']);
                });

                let taskSeries = [{
                    name: 'All',
                    data: taskData['All'],
                    type: 'bar',
                    showBackground: true,
                },{
                    name: 'Closed',
                    data: taskData['Closed'],
                    type: 'bar',
                    showBackground: true,
                }];

                let taskOption = {
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        top: '5%',
                        left: 'center'
                    },
                    xAxis: {
                        type: 'category',
                        data: taskLabels
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: taskSeries
                };

                taskOption && taskChart.setOption(taskOption);
            }

        }).catch((error) => {
            this.setState({
                loading: false,
                message: error.message,
            });

            if (error.message === 'Request failed with status code 401') {
                this.props.updateLoginStatus(false);
            }
        });
    }

    render() {
        return (
            <div>
                {/* Total widgets */}
                <ul className="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2 xl:grid-cols-3 mt-3">
                    {/* Total tasks */}
                    {this.state.data.widget_information && this.state.data.widget_information['status-total_tasks'] === 'on' ?
                    <li className="relative col-span-1 flex shadow-sm rounded-md pb-6 cursor-pointer" onClick={() => this.redirectToModule('Tasks')}>
                        <div
                            className='bg-pink-600 flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md'
                        >
                            <FontAwesomeIcon size='2x' icon={faTasks} />
                        </div>
                        <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                            <div className="flex-1 px-4 py-2 text-sm truncate">
                                <a href="#" className="text-gray-900 font-medium hover:text-gray-600">
                                    {this.state.data.widget_information
                                        && this.state.data.widget_information['updated_label-total_tasks']
                                        && this.state.data.widget_information['updated_label-total_tasks'].length > 0 ?
                                        this.state.data.widget_information['updated_label-total_tasks'] :
                                        this.state.data.widgets ? this.state.data.widgets['total_tasks'] : ''}
                                </a>
                                <p className="text-gray-500">{this.state.data.total_tasks} task(s)</p>
                            </div>
                        </div>
                    </li> : ''}

                    {/* Total invoices */}
                    {this.state.data.widget_information && this.state.data.widget_information['status-total_invoices'] === 'on' ?
                    <li className="relative col-span-1 flex shadow-sm rounded-md pb-6 cursor-pointer" onClick={() => this.redirectToModule('AOS_Invoices')}>
                        <div
                            className='bg-green-600 flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md'
                        >
                            <FontAwesomeIcon size='2x' icon={faFileInvoice} />
                        </div>
                        <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                            <div className="flex-1 px-4 py-2 text-sm truncate">
                                <a href="#" className="text-gray-900 font-medium hover:text-gray-600">
                                    {this.state.data.widget_information
                                        && this.state.data.widget_information['updated_label-total_invoices']
                                        && this.state.data.widget_information['updated_label-total_invoices'].length > 0 ?
                                        this.state.data.widget_information['updated_label-total_invoices'] :
                                        this.state.data.widgets ? this.state.data.widgets['total_invoices'] : ''}
                                </a>
                                <p className="text-gray-500">{this.state.data.total_invoices} invoice(s)</p>
                            </div>
                        </div>
                    </li> : ''}
                </ul>

                {/* Total widget ends here */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className=" bg-white shadow-md rounded-lg p-4" style={this.state.data.widget_information && this.state.data.widget_information['status-open_ticket_by_priority'] === 'on' ? {} : {display: 'none'}}>
                        <div className='flex flex-2'>
                            <h3 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate text-center">
                                {this.state.data.widget_information && this.state.data.widget_information['updated_label-open_ticket_by_priority'] && this.state.data.widget_information['updated_label-open_ticket_by_priority'].length > 0 ? this.state.data.widget_information['updated_label-open_ticket_by_priority'] : this.state.data.widgets ? this.state.data.widgets['open_ticket_by_priority'] : ''}
                            </h3>
                            <span className='ml-5 mt-3'>
                                <div className="relative inline-block text-left">
                                    <div>
                                        <button type="button" onClick={()=> { (this.state.openticketPriorityMenu) ? this.setState({openticketPriorityMenu:false}) : this.setState({openticketPriorityMenu:true})}} className="rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" id="menu-button" aria-expanded="true" aria-haspopup="true">
                                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                            </svg>
                                        </button>
                                    </div>
                                    {this.state.openticketPriorityMenu &&
                                    <div className="z-10 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                                        <div className="py-1" role="none">

                                            {Object.entries(ticketFilter).map(([key, value]) => (
                                                <a className="cursor-pointer text-gray-700 block px-4 py-2 text-sm" data-filter={key} data-type="priority" onClick={this.applyTicketFileter} role="menuitem" tabindex="-1" id="menu-item-2">{value}</a>
                                            ))}

                                        </div>
                                    </div>
                                    }
                                </div>
                            </span>
                        </div>
                        {this.state.openticketPriorityMessage ?
                            <Alert hideAlert={this.hideAlert} message={no_data_message} type="info" hideClose={true} />
                            :
                            <div id="open_tickets_by_priority" className="h-96 z-0"></div>
                        }

                    </div>
                    <div className=" bg-white shadow-md rounded-lg p-4" style={this.state.data.widget_information && this.state.data.widget_information['status-tickets_by_status'] === 'on' ? {} : {display: 'none'}}>

                    <div className='flex flex-2'>
                        <h3 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate text-center">
                            {this.state.data.widget_information && this.state.data.widget_information['updated_label-tickets_by_status'] && this.state.data.widget_information['updated_label-tickets_by_status'].length > 0 ? this.state.data.widget_information['updated_label-tickets_by_status'] : this.state.data.widgets ? this.state.data.widgets['tickets_by_status'] : ''}
                        </h3>
                        <span className='ml-5 mt-3'>
                                <div className="relative inline-block text-left">
                                    <div>
                                        <button type="button" onClick={()=> { (this.state.openticketStatusMenu) ? this.setState({openticketStatusMenu:false}) : this.setState({openticketStatusMenu:true})}} className="rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" id="menu-button" aria-expanded="true" aria-haspopup="true">
                                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                            </svg>
                                        </button>
                                    </div>
                                    {this.state.openticketStatusMenu &&
                                    <div className="z-10 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                                        <div className="py-1" role="none">

                                            {Object.entries(ticketFilter).map(([key, value]) => (
                                                <a  className="cursor-pointer text-gray-700 block px-4 py-2 text-sm" data-filter={key} data-type="status" onClick={this.applyTicketFileter} role="menuitem" tabindex="-1" id="menu-item-2">{value}</a>
                                            ))}

                                        </div>
                                    </div>
                                    }
                                </div>
                            </span>
                        </div>
                        {this.state.openticketStatusMessage ?
                            <Alert hideAlert={this.hideAlert} message={no_data_message} type="info" hideClose={true} />
                            :
                            <div id="tickets_by_status" className="h-96 z-0"></div>
                        }
                    </div>

                    <div style={this.state.data.widget_information && this.state.data.widget_information['status-latest_cases'] === 'on' ? {} : {display: 'none'}}>
                        <h3 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate pb-6">
                            {this.state.data.widget_information && this.state.data.widget_information['updated_label-latest_cases'] && this.state.data.widget_information['updated_label-latest_cases'].length > 0 ? this.state.data.widget_information['updated_label-latest_cases'] : this.state.data.widgets ? this.state.data.widgets['latest_cases'] : ''}
                        </h3>
                        <div className="bg-white shadow overflow-hidden rounded-md">
                            <ul className="divide-y divide-gray-200">
                                {this.state.data.latest_cases && this.state.data.latest_cases.map((case_info, index) => (
                                    <li key={index} className="px-6 py-4">
                                        <Link className="cursor-pointer font-medium text-skin-primary hover:text-skin-primary-darker" to={`${process.env.PUBLIC_URL}/Cases/detail/${case_info.id}`}>{case_info.name}</Link>
                                        <small className="text-sm pl-2 text-gray-500 truncate">({case_info.status})</small>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {this.state.data.latest_cases && this.state.data.latest_cases.length === 0 ? <Alert hideAlert={this.hideAlert} message={no_data_message} type="info" hideClose={true} /> : ''}
                    </div>
                    <div className=" bg-white shadow-md rounded-lg p-4" style={this.state.data.widget_information && this.state.data.widget_information['status-tasks'] === 'on' ? {} : {display: 'none'}}>
                        <h3 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate text-center">
                            {this.state.data.widget_information && this.state.data.widget_information['updated_label-tasks'] && this.state.data.widget_information['updated_label-tasks'].length > 0 ? this.state.data.widget_information['updated_label-tasks'] : this.state.data.widgets ? this.state.data.widgets['tasks'] : ''}
                        </h3>
                        <div id="tasks" className="h-96"></div>
                    </div>
                    <div className="sm:col-span-1 md:col-span-2 bg-white shadow-md rounded-lg p-4" style={this.state.data.widget_information && this.state.data.widget_information['status-tasks_all_vs_closed'] === 'on' ? {} : {display: 'none'}}>
                        <h3 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate text-center">
                            {this.state.data.widget_information && this.state.data.widget_information['updated_label-tasks_all_vs_closed'] && this.state.data.widget_information['updated_label-tasks_all_vs_closed'].length > 0 ? this.state.data.widget_information['updated_label-tasks_all_vs_closed'] : this.state.data.widgets ? this.state.data.widgets['tasks_all_vs_closed'] : ''}
                        </h3>
                        <div id="tasks_all_vs_closed" className="h-96"></div>
                    </div>
                    <div style={this.state.data.widget_information && this.state.data.widget_information['status-latest_documents'] === 'on' ? {} : {display: 'none'}}>
                        <h3 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate pb-6">
                            {this.state.data.widget_information && this.state.data.widget_information['updated_label-latest_documents'] && this.state.data.widget_information['updated_label-latest_documents'].length > 0 ? this.state.data.widget_information['updated_label-latest_documents'] : this.state.data.widgets ? this.state.data.widgets['latest_documents'] : ''}
                        </h3>
                        <div className="bg-white shadow overflow-hidden rounded-md">
                            <ul className="divide-y divide-gray-200">
                                {this.state.data.latest_documents && this.state.data.latest_documents.map((document_info, index) => (
                                    <li key={index} className="px-6 py-4">
                                        <Link className="cursor-pointer font-medium text-skin-primary hover:text-skin-primary-darker" to={`${process.env.PUBLIC_URL}/Documents/detail/${document_info.id}`}>{document_info.document_name}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {this.state.data.latest_documents && this.state.data.latest_documents.length === 0 ? <Alert hideAlert={this.hideAlert} message={no_data_message} type="info" hideClose={true} /> : ''}
                    </div>
                    <div style={this.state.data.widget_information && this.state.data.widget_information['status-meetings'] === 'on' ? {} : {display: 'none'}}>
                        <h3 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate pb-6">
                            {this.state.data.widget_information && this.state.data.widget_information['updated_label-meetings'] && this.state.data.widget_information['updated_label-meetings'].length > 0 ? this.state.data.widget_information['updated_label-meetings'] : this.state.data.widgets ? this.state.data.widgets['meetings'] : ''}
                        </h3>
                        <div className="bg-white shadow overflow-hidden rounded-md">
                            <ul className="divide-y divide-gray-200">
                                {this.state.data.meetings && this.state.data.meetings.map((meeting, index) => (
                                    <li key={index} className="px-6 py-4">
                                        <Link className="cursor-pointer font-medium text-skin-primary hover:text-skin-primary-darker pr-2" to={`${process.env.PUBLIC_URL}/Meetings/detail/${meeting.id}`}>{meeting.name}</Link>
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-skin-primary text-skin-muted">{meeting.status}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {this.state.data.meetings && this.state.data.meetings.length === 0 ? <Alert hideAlert={this.hideAlert} message={no_data_message} type="info" hideClose={true} /> : ''}
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;
